// extracted by mini-css-extract-plugin
module.exports = {"priceItem":"summary_priceItem__i6Wl_","remaining":"summary_remaining__Q9nYn","total":"summary_total__hKez2","lineItem":"summary_lineItem__D3yhB","divider":"summary_divider__UG8bO"};